/**
 * Upload Card
 * 
 * @Author: Focci
 * @Date: 2023-08-16 15:23:08
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-16 15:23:08
 */

import PropTypes from 'prop-types'
import CloseIcon from '@mui/icons-material/Close'
import { ButtonBase } from '@comp/material'
import { isFunction } from 'lodash-es'
import clsx from 'clsx'
import CircularProgress from '@mui/material/CircularProgress'

function CloseButton(buttonProps) {
  return (
    <ButtonBase className="rounded-full" {...buttonProps}>
      <div className="flex p-0.5 bg-red-500 rounded-full text-white">
        <CloseIcon sx={{ fontSize: '.5rem' }} />
      </div>
    </ButtonBase>
  )
}

export default function UploadCard({
  loading = false,
  onClose,
  children,
  src = '',
  className = 'h-16 w-16 border border-c6c flex items-center justify-center'
}) {
  return (
    <div className={clsx(['relative group group/upload-image', className])}>
      {isFunction(onClose) && (
        <div className="absolute -top-1 -right-1 z-1 hidden group-hover:flex z-10">
          <CloseButton onClick={onClose} />
        </div>
      )}
      {src && (
        <img 
          src={src} 
          alt=""
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      )}
      {loading && (
        <div className="absolute inset-0 bg-black/50 z-1 flex items-center justify-center">
          <CircularProgress size="1.2rem" />
        </div>
      )}
      {children}
    </div>
  )
}

UploadCard.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  src: PropTypes.string,
  className: PropTypes.string,
}
